import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectClient } from '@client/model/selectors';

import { computeTypeCFeasibility, type TypeCFeasibility } from '../lib/ccrc-type-c-feasibility';

export function useTypeCFeasibility(): TypeCFeasibility | null {
  const client = useSelector(selectClient);

  return useMemo(() => {
    if (!client) {
      return null;
    }
    try {
      return computeTypeCFeasibility(client);
    } catch {
      return null;
    }
  }, [client]);
}
